module.exports = __webpack_public_path__ + "img/contactCode.41504293.jpg";